module.exports = __webpack_public_path__ + "static/media/merchentbanner.ffa76e14.jpg";